<template>
  <div class="panel-item oms-theme">
    <template v-if="where == 'setting'">
      <p>
        <i class="ark-icon iconfont iconmd-color-palette iconfont" />
        主题色
        <!-- <Icon type="ios-color-fill" class="oms-skin-pick" :style="`color: ${defaultColor}; font-size: 23px`" /> -->
        <el-color-picker v-model="defaultColor" @change="colorPick" :predefine="predefineColors" :class="['oms-skin-pick', where]"></el-color-picker>
      </p>
    </template>
    <template v-else>
      <i class="iconfont icon-skin" />
      <el-color-picker v-model="defaultColor" @change="colorPick" :predefine="predefineColors" :class="['oms-skin-pick', where]"></el-color-picker>
      <span class="tag-title">换肤<Icon type="ios-arrow-down" /></span>
    </template>
  </div>
</template>

<script>
export default {
  name: "OmsTheme",
  components: {},
  props: {
    where: {
      type: String,
      default() {
        return ''
      }
    },
  },
  data() {
    return {
      defaultColor: '#0F3365',
      predefineColors: [
        // '#f1b8f1', // 马卡龙粉
        '#0F3365',
        '#5461B8',
        '#F1ACB8',
        '#FF4500',
        // '#FF8C00',
        // '#FFD700',
        '#2F9B2F',
        // '#00CEX1',
        '#3870C1',
        '#1E90FF',
        '#C71585',
        "#FF7800",
        "#00BABD",
      ],
      ColorMatch: {
        // "#F1B8F1":"#b8f1ed",
        '#0F3365': "#0068B7",
        "#F1ACB8": "#3870C1", // 粉-蓝
        "#FF4500":"#037117",
        "#FF8C00": "#0D8497",
        "#FFD700": "#F5AA12",
        "#C71585": "#039754",
        "#FF7800": "#C505AB",
      },
    }
  },
  created() {
    this.setDefauleTheme()
  },
  mounted() {
    this.navColor()
  },
  methods: {
    /* ---------------- 换肤处理Start ---------------- */
    setDefauleTheme(obj) {
      let initTheme = obj;
      const getCacheTheme = localStorage.getItem('cacheTheme')
      if (getCacheTheme) {
        initTheme = JSON.parse(getCacheTheme)
        this.defaultColor = initTheme['--b1-color']
        if (typeof(initTheme['--b1-color_q1']) == 'object') {
          localStorage.setItem('cacheTheme', '')
          this.setDefauleTheme()
        }
      } else {
        initTheme = {
          // '--b1-color': "#1A1917",
          // '--b1-color_q1': "#1A1917",
          // '--b1-color_x1': "#FED314",
          '--b1-color': "#0F3365",
          '--b1-color_q1': "#2b4874",
          '--b1-color_q2': "#0068b7",
          '--b1-color_q5': "#f0f8ff",
          '--b1-color_q6': "#99C2F1",
          '--b1-color_x1': "#173155",
          '--b1-color_x2': "#001F4A",
          '--b2-color': "#0068b7",
          '--b2-color_q1': "#F65B3C",
          '--b2-color_x1': "#D12705",
          '--t-text': "#fff"
        }
        const testKeys = ['106.14.190.204:28080', 'test', '127.0.0.1', 'localhost']
        const flag = testKeys.some(i => window.location.origin.includes(i))
        if (flag) {
          initTheme = {
            "--b1-color": "#025A5C",
            "--b1-color_q1": "#0E6665",
            "--b1-color_q5": "#FFFDFF",
            "--b1-color_q6": "#47BB95",
            "--b1-color_x1": "#004E53",
            "--b1-color_x2": "#003E42",
            "--b2-color": "#C657FF",
            "--b2-color_q1": "#DD9BFF",
            "--b2-color_x1": "#AF13FF",
            "--t-text": "#fff"
          }
        }
      }
      for (const it of Object.entries(initTheme)) {
        this.Co(it[0], it[1])
      }
    },
    // 初始皮肤 -左导航hover效果
    navColor() {
      this.$nextTick(() => {
        if (localStorage.getItem('cacheTheme')) {
          $('.NavigatorVertical').removeClass('newColor')
        } else {
          $('.NavigatorVertical').addClass('newColor')
        }
      })
    },
    Co(x, y) {
      document.documentElement.style.setProperty(x, y);
    },
    colorPick(_val) {
      const val = _val
      this.defaultColor = val
      console.log('-----pick::', val);
      if (!val) {
        // 点击'清空'时：
        localStorage.setItem('cacheTheme', '')
        this.setDefauleTheme()
        this.navColor()
        return
      }
      this.navColor()
      // 颜色深度处理
      const Color = require('color');
      let b1, b1q1, b1q2, b1q5, b1q6,
      b1x1,
      b2, text;
      b1 = Color(val)
      const { r, g, b } = b1.object()

      // console.log('b1', Color('#5461b8').color);
      // console.log('x1', Color('#4855af').color);
      // console.log('q6', Color('#99C2F1').color);
      // console.log('b2', Color('#7450B7').color);

      // b1q1 = b1.lighten(0.1).hex()
      // b1x1 = b1.saturate(0.7).darken(0.2).hex()
      // b1q2 = b1.lighten(0.5).hex()
      // b2 = b1.saturate(0.75).rotate(155).lighten(0.3); // 逆时针


      b1q1 = Color({ r: r+12, g: g+12, b: b+9 }).hex()
      b1q6 = Color({ r: r+69, g: g+97, b: b+57 }).hex()
      b1x1 = Color({ r: r-12, g: g-12, b: b-9 }).hex()
      b2 = Color({ r: 200-r, g: 177-g, b: 367-b }).hex()

      // b2 不能太浅
      const { r: r_2, g: g_2, b: b_2 } = Color(b2).object()
      if (r_2 * 0.299 + g_2 * 0.578 + b_2 * 0.114 > 155) {
        b2 = Color(b2).darken(0.2).hex()
      }

      // console.log('color::', b1.hex(), b1q1, b1x1, b2);

      b1q5 = Color({ r: 303-r, g: 319-g, b: 407-b }).lighten(0.05).hex()

      if (r * 0.299 + g * 0.578 + b * 0.114 >= 172) { // 浅色 192
        text = "#17233d"
        b2 = b1.darken(0.4).rotate(-80).hex(); // .desaturate(0.75)
        const huBuSe = Color({ r: 255-r, g: 255-g, b: 255-b })
        const maKaLongSe = Color({ r: 430-r, g: 401-g, b: 437-b })
        const fanSe = Color({ r: 285-r, g: 285-g, b: 385-b })
        b1q2 = fanSe.hex()
        b1q5 = maKaLongSe.lighten(0.05).hex()
      } else {
        text = "#fff"
      }
      let formatColor = [];
      for (const it of this.predefineColors) {
        formatColor.push(Color(it).hex())
      }
      if (formatColor.includes(val) && this.ColorMatch[val]) {
        b2 = this.ColorMatch[val]
      }
      const cacheTheme = {
        "--b1-color": val,
        "--b1-color_q1": b1q1,
        "--b1-color_q2": b1q2,
        "--b1-color_q5": b1q5,
        "--b1-color_q6": b1q6,
        "--b1-color_x1": b1x1,
        "--b1-color_x2": Color(b1x1).darken(0.2).hex(),
        "--b2-color": b2,
        "--b2-color_q1": Color(b2).lighten(0.2).hex(),
        "--b2-color_x1": Color(b2).darken(0.2).hex(),
        "--t-text": text
      }
      // this.setDefauleTheme(cacheTheme)
      for (const it of Object.entries(cacheTheme)) {
        this.Co(it[0], it[1])
      }
      localStorage.setItem('cacheTheme', JSON.stringify(cacheTheme))

      /* for (const [x,y] of Object.entries(cacheTheme)) {
        const cur = getComputedStyle(document.documentElement).getPropertyValue(x)
        cacheTheme[x] = cur
      } */
    },
    /* ---------------- 换肤处理End ---------------- */
  }
}
</script>

<style lang="scss">
.oms-theme {
  position: relative;
  .oms-skin-pick {
    position: absolute;
    right: 15px;
    top: 13px;
    &.nav {
      position: absolute;
      left: 4px;
      top: 4px;
      opacity: 0;
      .el-color-picker__trigger {
        height: 28px;
        width: 28px;
        .el-icon-arrow-down:before {
          color: #fff;
        }
      }
    }
  }
  /deep/ .el-color-dropdown.el-color-picker__panel {
    top: 50px;
  }
  .iconios-shirt-outline:before {
    font-size: 20px;
  }
  .el-color-picker__trigger {
    height: 28px;
    width: 28px;
    .el-icon-arrow-down:before {
      color: #fff;
    }
  }
}
</style>
